// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8i-4";
export var collapsed = "_8i-1";
export var headerBar = "_8i-0";
export var leftHeaderContent = "_8i-3";
export var subjectContainer = "_8i-2";